import axiosInstance from "./axiosInstance";


// Fetch user list
export const fetchUsers = async (userInfo) => {
  const res = await axiosInstance.get('/Dash/usermaster', {
    params: {
      emp_code: userInfo.empCode,
      company_code: userInfo.company_code,
      user_role: userInfo.roleID,
      user_type: 'emp'
    }
  });
  const raw = res.data?.data?.[0]?.get_user_data_by_type;
  return raw?.usermaster || [];
};

// Save a user
export const saveUserAPI = async (data) => {
  const res = await axiosInstance.post('/Dash/add_employee', data);
  return res.data;
};

// Fetch user details by emp_code
export const fetchUserDetails = async (emp_code) => {
  const res = await axiosInstance.get('/master/user_details', {
    params: { emp_code }
  });
  return res.data?.data?.[0] || [];
};


export const fetchRoles = async () => {
  const res = await axiosInstance.get('/Dash/role_master');
  return res.data?.data;
};

